var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-7{fill:none;}.cls-2{fill:#f2f2f2;}.cls-2,.cls-3,.cls-4,.cls-6{stroke:#000;stroke-width:5px;}.cls-2,.cls-3,.cls-4,.cls-6,.cls-7{stroke-linecap:round;stroke-linejoin:round;}.cls-4{fill:#668bff;}.cls-5{clip-path:url(#clip-path);}.cls-7{stroke:#f2f2f2;stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M781.41,570.36s15.2-192.14,19.35-219.79-15.21-52.53-29-51.14-24.88,2.76-37.32-1.39-26.27-38.7-29-37.32-22.12,18-27.65,8.29-19.67-42.85-29.35-37.32-24.56,31.8-43.91,13.83-22.12,5.52-31.79,11-18-2.76-34.56-16.58-56.67,66.35-56.67,66.35-18-19.36-27.65-22.12S422,368.54,422,368.54s-16.59-33.17-22.12-12.44,27.65,214.26,27.65,214.26,15.2-149.29,69.11-154.82,80.18,82.94,106.12,82.94,58.38-82.94,105.37-80.18S781.41,570.36,781.41,570.36Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1096.94,1200H103.06a1.35,1.35,0,0,1,0-.18c1.49-5,34.83-116.18,48.33-127,13.82-11.06,286.13-112,286.13-112H762.43s272.31,100.9,286.13,112c13.51,10.82,46.84,122,48.33,127C1096.92,1199.94,1096.94,1200,1096.94,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1007.82,1200c4.3-11.13,14.34-32.58,22.77-48.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M638.78,987.12c-2.28-15.16-3.53-26.26-3.53-26.26h-65s-1.78,11.1-4.39,26.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M635.25,960.86s-14.51,67.73-33.17,67.73-31.8-67.73-31.8-67.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M646,1200H567.36c0-.06,0-.11,0-.18,5-79,14.66-171.23,34.69-171.23,16.85,0,32.62,91.93,43.94,171.23A1.35,1.35,0,0,1,646,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M501.64,944.27h-6c-20.61,0-2.94-17.8,2.76-23.5,4.15-4.14,4.15-5.53-15.2-2.76s-45.62,42.85-45.62,42.85c-6.38,4.13,92.61,90.66,103.67,88.47,3.84-.76,33.87-87.78,33.87-87.78s56.68-1.38,58.06,0,14.68,87.78,27,87.78c18,0,102.29-88.47,102.29-88.47s-27.64-34.56-34.55-41.47-11.06-6.91-22.12-4.15c6.91,12.44,27.64,29,9.67,29H501.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.21,1151.61c8.43,15.81,18.46,37.26,22.76,48.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.57,936c3.8,5.86-7.87,9.58-12.92,7.55-1.81-3.72-2.28-21.38.48-21.38S716.56,928.58,719.57,936Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.52,936c-3.8,5.86,7.86,9.58,12.92,7.55,1.81-3.72,2.28-21.38-.48-21.38S490.53,928.58,487.52,936Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ear"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431,591.33s-68.17-9.27-68.17,58.47,74.75,63.82,74.75,63.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776.69,591.33s66.92-9.27,66.92,58.47-69.68,63.82-69.68,63.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Neck",
    className: "cls-2",
    d: "M704.84,870v74.23H501.64V869.63h8.91c34.08,14.7,74,25.57,100.83,25.57C639.34,895.2,674.3,885.29,704.84,870Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Face",
    className: "cls-2",
    d: "M781.71,566.49h0c0,1.6-.89,86.66-2.78,127.12C775.8,760.69,769.5,819.48,757.45,833c-13.09,13.85-31.82,26.67-52.61,37-30.54,15.25-65.5,25.16-93.46,25.16-26.85,0-66.75-10.87-100.83-25.57C485,858.6,462.68,845.4,451.64,833c-19.44-21.82-24.25-263.47-24.25-263.49s-5.71-120.8,85.53-176.09,183.84-16.59,222.55,33.18S781.71,566.49,781.71,566.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520.15,773.56q88.47,63,176.94,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M599.71,708.59c46.9,0,46.9-56.68,0-56.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M654.23,603.53c0-23.72,60.83-23.72,60.83,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M481.45,603.53c0-23.72,60.82-23.72,60.82,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462,559.79c9.24-24.16,92.72-25.37,99.74,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M734.52,559.79c-9.25-24.16-92.73-25.37-99.75,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699,
    y1: 722.77,
    x2: 724.94,
    y2: 738.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 502.18,
    y1: 730.71,
    x2: 488.36,
    y2: 748.68
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hair"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M781.41,570.36s15.2-192.14,19.35-219.79-15.21-52.53-29-51.14-24.88,2.76-37.32-1.39-26.27-38.7-29-37.32-22.12,18-27.65,8.29-19.67-42.85-29.35-37.32-24.56,31.8-43.91,13.83-22.12,5.52-31.79,11-18-2.76-34.56-16.58-56.67,66.35-56.67,66.35-18-19.36-27.65-22.12S422,368.54,422,368.54s-16.59-33.17-22.12-12.44,27.65,214.26,27.65,214.26,15.2-149.29,69.11-154.82,80.18,82.94,106.12,82.94,58.38-82.94,105.37-80.18S781.41,570.36,781.41,570.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M753.2,377.78c2.15,32.3,3,70.93,2.36,103.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M700.85,324.69l9.75,93.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M652.54,381.67q2.81,33.42,2.81,67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M595.56,367.32c7.7,40.95,9,95.31,11.88,136.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M553.91,392.41c-.79,18.75-1.12,45.55-.22,64.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M511.81,338.57c-1.2,20.3,2.21,65.42,4.38,85.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M451.12,357.75c2.67,29.09,7.28,66.27,11.32,95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M426,434.76c3.39,25.19,9.32,73,12.72,98.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M451.19,284.2s11.25,33.75,15,63.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 421.19,
    y1: 347.95,
    x2: 438.69,
    y2: 424.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M534.94,234.2c-5,12.5-1.25,112.5,0,132.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M569.94,241.7c0,16.25.62,139.37,3.12,154.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M621.19,241.7c0,20,4.37,149.37,3.12,163.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M684.94,259.2c-5,17.5-5,126.25-3.75,131.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M734.94,278c2.5,35-.63,111.87-1.88,126.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M801.19,300.45c-1.25,32.5-17.5,126.25-16.25,138.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M784.94,469.2c0,25-2.71,89.57-3.23,97.29"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar07);
export default __webpack_public_path__ + "static/media/Avatar-07.ef5ef708a82af556b7b133a104d735f6.svg";
export { ForwardRef as ReactComponent };